import React from "react";
import styles from "./commonStyles";
import { useTranslation } from "react-i18next";

const CardComponent = ({ data, image, onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      className="w-100 text-white marginTop20 padding24"
      style={{
        ...styles.common_border_styles,
      }}
    >
      <div className="d-flex justify-content-between align-items-start text-align text-center mb-2 mb-md-4">
        <div className="justify-content-center align-items-center d-flex">
          <img src={image} alt="icon" className="Review-icon-responsive" />
        </div>
        <button
          className="bg-transparent border-0 text-white text-decoration-underline fontSize14Medium lineHeight24 custom-pink-button"
          onClick={onClick}
        >
          {t("change")}
        </button>
      </div>

      <div className="row g-3">
        {Object.entries(data).map(([label, value]) => {
          if (value != "" || value.length > 0) {
            return (
              <div key={label} className="col-12 col-md-6">
                <div className="fontSize14Medium mb-0 mb-md-1 text-white lineHeight24">
                  {t(`${label}`)}
                </div>
                <div className="fontSize18Medium lineHeight24 text-white">
                  {value}
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default CardComponent;
